import React, { useContext } from 'react';

/**
 * Put states and handlers of Subscription Ads Wizard in Context
 */

export const SubAdsWizardContext = React.createContext({});

export const useSubAdsWizardContext = () => useContext(SubAdsWizardContext);
